// extracted by mini-css-extract-plugin
export default {"Big":"label_Big__X-ZqS","Label":"label_Label__9Ovt7","NoMargin":"label_NoMargin__RxBJx","Secondary":"label_Secondary__srAi2"};